function noop() {}
var localStorageManager = function(param) {
    var key = param.key, storageWindow = param.storageWindow;
    if (!storageWindow && typeof window !== 'undefined') {
        storageWindow = window;
    }
    return {
        get: function(defaultValue) {
            if (typeof window === 'undefined') {
                return undefined;
            }
            if (!storageWindow) {
                return defaultValue;
            }
            var value;
            try {
                value = storageWindow.localStorage.getItem(key);
            } catch (e) {
            // Unsupported
            }
            return value || defaultValue;
        },
        set: function(value) {
            if (storageWindow) {
                try {
                    storageWindow.localStorage.setItem(key, value);
                } catch (e) {
                // Unsupported
                }
            }
        },
        subscribe: function(handler) {
            if (!storageWindow) {
                return noop;
            }
            var listener = function(event) {
                var value = event.newValue;
                if (event.key === key) {
                    handler(value);
                }
            };
            storageWindow.addEventListener('storage', listener);
            return function() {
                storageWindow.removeEventListener('storage', listener);
            };
        }
    };
};
export default localStorageManager;
